import { ActionsUnion } from '../types';
import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { Contact, ProjectSubcontractor, SubcontractorNotificationEmail } from './types';
import { NotificationsEmail, SubcontractorDetailsRequest } from '../project/types';

export const Actions = {
  getExternalUserContacts: () => createAction(ActionTypes.GET_EXTERNAL_USER_CONTACTS),
  getExternalUserContactsSuccess: (data: Contact[]) => createAction(ActionTypes.GET_EXTERNAL_USER_CONTACTS_SUCCESS, data),
  getExternalUserContactsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_EXTERNAL_USER_CONTACTS_ERROR, error),

  addExternalUserContact: () => createAction(ActionTypes.ADD_EXTERNAL_USER_CONTACT),
  addExternalUserContactSuccess: () => createAction(ActionTypes.ADD_EXTERNAL_USER_CONTACT_SUCCESS),
  addExternalUserContactError: (error: RestErrorResponse) => createAction(ActionTypes.ADD_EXTERNAL_USER_CONTACT_ERROR, error),

  updateExternalUserContact: () => createAction(ActionTypes.UPDATE_EXTERNAL_USER_CONTACT),
  updateExternalUserContactSuccess: () => createAction(ActionTypes.UPDATE_EXTERNAL_USER_CONTACT_SUCCESS),
  updateExternalUserContactError: (error: RestErrorResponse) => createAction(ActionTypes.UPDATE_EXTERNAL_USER_CONTACT_ERROR, error),

  changeUserAccountStatus: () => createAction(ActionTypes.CHANGE_USER_ACCOUNT_STATUS),
  changeUserAccountStatusSuccess: () => createAction(ActionTypes.CHANGE_USER_ACCOUNT_STATUS_SUCCESS),
  changeUserAccountStatusError: (error: RestErrorResponse) => createAction(ActionTypes.CHANGE_USER_ACCOUNT_STATUS_ERROR, error),

  getExternalUsersByProjectId: () => createAction(ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID),
  getExternalUsersByProjectIdSuccess: (data: ProjectSubcontractor[]) => createAction(ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID_SUCCESS, data),
  getExternalUsersByProjectIdError: (error: RestErrorResponse) => createAction(ActionTypes.GET_EXTERNAL_USERS_BY_PROJECT_ID_ERROR, error),

  changeSubcontractorStatus: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS),
  changeSubcontractorStatusSuccess: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_SUCCESS),
  changeSubcontractorStatusError: (error: RestErrorResponse) => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_ERROR, error),

  changeSubcontractorEmail: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS),
  changeSubcontractorEmailSuccess: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_SUCCESS),
  changeSubcontractorEmailError: (error: RestErrorResponse) => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_STATUS_ERROR, error),

  createSubcontractorAccount: () => createAction(ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT),
  createSubcontractorAccountSuccess: () => createAction(ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT_SUCCESS),
  createSubcontractorAccountError: (error: RestErrorResponse) => createAction(ActionTypes.CREATE_SUBCONTRACTOR_ACCOUNT_ERROR, error),

  getSubcontractorNotificationEmailSettings: () => createAction(ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS),
  getSubcontractorNotificationEmailSettingsSuccess: (data: SubcontractorNotificationEmail[]) =>
    createAction(ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_SUCCESS, data),
  getSubcontractorNotificationEmailSettingsError: (error: RestErrorResponse) =>
    createAction(ActionTypes.GET_SUBCONTRACTORS_NOTIFICATION_EMAIL_SETTINGS_ERROR, error),

  saveSubcontractorNotificationEmail: () => createAction(ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL),
  saveSubcontractorNotificationEmailSuccess: (data: NotificationsEmail) =>
    createAction(ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_SUCCESS, data),
  saveSubcontractorNotificationEmailError: (error: RestErrorResponse) => createAction(ActionTypes.SAVE_SUBCONTRACTOR_NOTIFICATION_EMAIL_ERROR, error),

  editSubcontractorAccount: () => createAction(ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT),
  editSubcontractorAccountSuccess: (data: SubcontractorDetailsRequest) => createAction(ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT_SUCCES, data),
  editSubcontractorAccountError: (error: RestErrorResponse) => createAction(ActionTypes.EDIT_SUBCONTRACTOR_ACCOUNT_ERROR, error),

  changeSubcontractorVisibility: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_VISIBILITY),
  changeSubcontractorVisibilitySuccess: () => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_VISIBILITY_SUCCESS),
  changeSubcontractorVisibilityError: (error: RestErrorResponse) => createAction(ActionTypes.CHANGE_SUBCONTRACTOR_VISIBILITY_ERROR, error)
};

export type SubcontractorActions = ActionsUnion<typeof Actions>;
